import { AssetClassAnnualReturns } from 'types/annual-returns';

export const annualReturnsDisclosureModalProps = {
	content: [
		'1. Figures represent the weighted average aggregate performance of all client accounts during the periods indicated, including any shares acquired as a result of the reinvestment of dividends, and net of a 0.15% advisory fee, if applicable. Commissions are not considered since clients of Fundrise Advisors are not charged trading commissions or any other transaction-based fees. Returns were calculated using the <a href="https://www.investopedia.com/terms/m/modifieddietzmethod.asp#:~:text=The%20modified%20Dietz%20method%20is,a%20specified%20period%20of%20time." target="_blank">Modified Dietz method</a>. This information is presented for informational purposes only. Past performance is not indicative of future results, and any investment carries with it the risk of loss.',
		'2. Specifically, the S&P 500 index total return, which includes both dividends and capital gains / losses, for the period indicated. The index includes 500 leading companies and covers approximately 80% of available market capitalization of US publicly listed stocks. As an index, the S&P 500 is inherently not investable, and is presented for informational purposes only.',
		'3. Specifically, the National Association of Real Estate Investment Trusts (NAREIT) All US REITs index total return, which includes both dividends and capital gains / losses, for the period indicated. This index covers all publicly listed US REITs and is designed to present investors with a comprehensive family of REIT performance indexes that spans the commercial real estate space across the US economy, with exposure to all investment and property sectors. As an index, the FTSE NAREIT All REITs index is inherently not investable, and is presented for informational purposes only.'
	],
	centeredContent: false
};

export const annualReturnsData: AssetClassAnnualReturns = {
	annualReturnsData: [
		{
			name: '2022 YTD Through Q3',
			fundrise: '5.40%',
			reits: '-28.34%',
			stocks: '-23.87%'
		},
		{
			name: '2021',
			fundrise: '22.99%',
			reits: '39.88%',
			stocks: '28.71%'
		},
		{
			name: '2020',
			fundrise: '7.31%',
			reits: '-5.86%',
			stocks: '18.40%'
		},
		{
			name: '2019',
			fundrise: '9.16%',
			reits: '28.07%',
			stocks: '31.49%'
		},
		{
			name: '2018',
			fundrise: '8.81%',
			reits: '-4.10%',
			stocks: '-4.38%'
		},
		{
			name: '2017',
			fundrise: '10.63%',
			reits: '9.27%',
			stocks: '21.83%'
		}
	],
	annualReturnsSummaries: [
		{
			name: 'Worst quarter',
			fundrise: '0.09%',
			reits: '-25.42%',
			stocks: '-19.60%'
		},
		{
			name: 'Best quarter',
			fundrise: '9.40%',
			reits: '16.70%',
			stocks: '20.54%'
		},
		{
			name: 'Positive quarters',
			fundrise: '23',
			reits: '17',
			stocks: '17'
		},
		{
			name: 'Negative quarters',
			fundrise: '0',
			reits: '6',
			stocks: '6'
		},
		{
			name: 'Avg. income return',
			fundrise: '5.42%',
			reits: '4.34%',
			stocks: '2.17%'
		}
	]
};
